import { render, staticRenderFns } from "./monthly-payment-view.vue?vue&type=template&id=72150d7b&"
import script from "./monthly-payment-view.vue?vue&type=script&lang=js&"
export * from "./monthly-payment-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports